/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { Heading } from 'sarsaparilla';

import SearchFilterActivities from '../../../components/SearchFilterActivities';
import {
    countUiFilterSelections,
    getUiFilterSelections,
    type UiFiltersState,
} from '../../../utils/filters';
import { AgenciesFilters } from './AgenciesFilters';

export type AdditionalPreferencesFiltersProps = {
    uiFilters: UiFiltersState;
    onFilterToggle: (filterName: string, item: { key: string }) => void;
    hideActivities?: boolean;
};

/** Agency and activity filters */
export function AdditionalPreferencesFilters({
    uiFilters,
    onFilterToggle,
    hideActivities = false,
}: AdditionalPreferencesFiltersProps) {
    const countKeys = hideActivities ? ['agencies'] : ['agencies', 'activities'];
    const additionalPreferencesCount = countUiFilterSelections(uiFilters, countKeys);
    return (
        <div className="mb-4">
            <div className="search-filters-section-header rounded-layout">
                <Heading headingLevel={2} appearance="h5">
                    Additional Preferences.
                </Heading>
                <span className="search-filters-section-header__count">
                    {additionalPreferencesCount}{' '}
                    {additionalPreferencesCount === 1 ? 'Filter' : 'Filters'} Selected
                </span>
            </div>
            <div className="search-filters-filter-container pt-0">
                {process.env?.SEARCH?.showFederalAgencies && (
                    <AgenciesFilters
                        uiFilters={{
                            agencies: getUiFilterSelections(uiFilters, 'agencies'),
                        }}
                        onFilterToggle={onFilterToggle}
                        expandable
                    />
                )}

                {!hideActivities && (
                    <SearchFilterActivities
                        uiFilters={{
                            activities: getUiFilterSelections(uiFilters, 'activities'),
                        }}
                        onFilterToggle={onFilterToggle}
                        enableAll
                        showCounts={false}
                        expandable
                    />
                )}
            </div>
        </div>
    );
}
